import React, { useContext, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import JSONPretty from 'react-json-pretty';

import FireDataContext from '../../../services/firebase/FireDataContext';
import LoggingContext from '../../../services/logging/LoggingContext';
import MemberMiniMenu from '../../members/menus/MemberMiniMenu';
import AuthContext from '../../../services/firebase/AuthContext';

const newStyle = { color: 'greenyellow', backgroundColor: 'black', padding: '0.5rem', marginBottom: '1rem' };
const oldStyle = { color: 'darkgray', backgroundColor: 'black', padding: '0.5rem', marginBottom: '1rem' };

const ErrorLogPage = () => {
    const db = useContext(FireDataContext);
    const Errata = useContext(LoggingContext);
    const { currentUser } = useContext(AuthContext);
    const [errors, setErrors] = useState([]);

    useEffect(() => {
        const cancel = db.subscribe({
            path: `errors`,
            hook: data => {
                setErrors(data)
            },
            context: 'ErrorLogPage'
        });

        return cancel;

    }, [db, Errata, currentUser])

    return (
        <MemberMiniMenu>
            {
                errors?.map(e => {
                    return {
                        ...e,
                        timestamp: dayjs(e.ts).format('ddd D MMM YYYY HH:mm:ss'),
                        age: dayjs().diff(dayjs(e.ts), 'minute')
                    }
                })
                .sort((a, b) => a.age - b.age)
                .map(e => {
                    return <JSONPretty data={e} key={e.id} style={e.age < 30 ? newStyle : oldStyle} />
                })
            }
        </MemberMiniMenu>
    );
};

export default ErrorLogPage;